/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Address$inboundSchema, Address$outboundSchema, } from "./address.js";
import { TaxIDFormat$inboundSchema, TaxIDFormat$outboundSchema, } from "./taxidformat.js";
/** @internal */
export const CustomerMetadata1$inboundSchema = z.union([z.string(), z.int(), z.number(), z.boolean()]);
/** @internal */
export const CustomerMetadata1$outboundSchema = z.union([z.string(), z.int(), z.number(), z.boolean()]);
export function customerMetadata1ToJSON(customerMetadata1) {
    return JSON.stringify(CustomerMetadata1$outboundSchema.parse(customerMetadata1));
}
export function customerMetadata1FromJSON(jsonString) {
    return safeParse(jsonString, (x) => CustomerMetadata1$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CustomerMetadata1' from JSON`);
}
/** @internal */
export const CustomerTaxId$inboundSchema = z.union([z.string(), TaxIDFormat$inboundSchema]);
/** @internal */
export const CustomerTaxId$outboundSchema = z.union([z.string(), TaxIDFormat$outboundSchema]);
export function customerTaxIdToJSON(customerTaxId) {
    return JSON.stringify(CustomerTaxId$outboundSchema.parse(customerTaxId));
}
export function customerTaxIdFromJSON(jsonString) {
    return safeParse(jsonString, (x) => CustomerTaxId$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CustomerTaxId' from JSON`);
}
/** @internal */
export const Customer$inboundSchema = z.pipe(z.object({
    id: z.string(),
    created_at: z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    modified_at: z.nullable(z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v)))),
    metadata: z.record(z.string(), z.union([z.string(), z.int(), z.number(), z.boolean()])),
    external_id: z.nullable(z.string()),
    email: z.string(),
    email_verified: z.boolean(),
    name: z.nullable(z.string()),
    billing_address: z.nullable(Address$inboundSchema),
    tax_id: z.nullable(z.array(z.nullable(z.union([z.string(), TaxIDFormat$inboundSchema])))),
    organization_id: z.string(),
    deleted_at: z.nullable(z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v)))),
    avatar_url: z.string(),
}), z.transform((v) => {
    return remap$(v, {
        "created_at": "createdAt",
        "modified_at": "modifiedAt",
        "external_id": "externalId",
        "email_verified": "emailVerified",
        "billing_address": "billingAddress",
        "tax_id": "taxId",
        "organization_id": "organizationId",
        "deleted_at": "deletedAt",
        "avatar_url": "avatarUrl",
    });
}));
/** @internal */
export const Customer$outboundSchema = z.pipe(z.object({
    id: z.string(),
    createdAt: z.pipe(z.date(), z.transform(v => v.toISOString())),
    modifiedAt: z.nullable(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    metadata: z.record(z.string(), z.union([z.string(), z.int(), z.number(), z.boolean()])),
    externalId: z.nullable(z.string()),
    email: z.string(),
    emailVerified: z.boolean(),
    name: z.nullable(z.string()),
    billingAddress: z.nullable(Address$outboundSchema),
    taxId: z.nullable(z.array(z.nullable(z.union([z.string(), TaxIDFormat$outboundSchema])))),
    organizationId: z.string(),
    deletedAt: z.nullable(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    avatarUrl: z.string(),
}), z.transform((v) => {
    return remap$(v, {
        createdAt: "created_at",
        modifiedAt: "modified_at",
        externalId: "external_id",
        emailVerified: "email_verified",
        billingAddress: "billing_address",
        taxId: "tax_id",
        organizationId: "organization_id",
        deletedAt: "deleted_at",
        avatarUrl: "avatar_url",
    });
}));
export function customerToJSON(customer) {
    return JSON.stringify(Customer$outboundSchema.parse(customer));
}
export function customerFromJSON(jsonString) {
    return safeParse(jsonString, (x) => Customer$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Customer' from JSON`);
}
//# sourceMappingURL=customer.js.map